const FormatPrice = ({price})=>{
return Intl.NumberFormat("en-PK", {
    style: "currency",
    currency:"PKR",
    maximumFractionDigits:1,
}).format(price/10)

};

export default FormatPrice